import React from "react";
import { connect } from "react-redux";
import Loader from "Components/loader/Loader";
import PropTypes from "prop-types";
import * as resActions from "../../modules/resources";
import * as sessionActions from "../../modules/session";
import t from "Utils/translation";
import EditOrder from "./edit_form/EditOrder";
import Recap from "./edit_form/Recap";
import YearlyOrder from "./YearlyOrder";
import Stepper from "Components/stepper2/Stepper";
import { withRouter } from "react-router";
import QboxmailApi from "../../qboxmailApi";
import { alertError, alertSuccess } from "Utils/alerts";

class OrderScreen extends React.Component {
  constructor(props) {
    super(props);

    // get all user domains
    props.getDomains({ per: 99999 });
    props.getOrders({ per: 99999 });
    props.getPrices();

    this.state = {
      upgrading: false,
      action: null,
      annually: false,
      upgradingDomains: null,
      showDetails: false,
      currentStep: 1,
      isUpgradingDomain: false,
      isAddingDomain: false,
      estimate: null,
      normalizedOrders: {},
      steps: {
        1: {
          component: <EditOrder />,
        },
        2: {
          component: <EditOrder />,
        },
        3: {
          component: <Recap />,
        },
      },
      upgradingProducts: {},
    };
  }

  componentDidMount() {
    const loggedUser = this.context.getLoggedUser();

    // se non ha un ordine fatto e non lo ha appena creato, rendirizzalo al form
    if (!loggedUser.orders?.[0]?.id) {
      this.props.history.push("/orders/new#1");
    }

    if (loggedUser.orders?.[0]?.billing_cycle === "annually") {
      this.setState({ annually: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (!IS_APP) {
      // render the right step if the user click back in the browser
      const nextStep = this.props.location.hash.replace("#", "");
      const prevStep = prevProps.location.hash.replace("#", "");

      // this happens when user clicks browser's go back button when in the wizard
      if ((!nextStep || nextStep === "" || nextStep === "/") && prevStep !== nextStep) {
        this.backToList();
      }

      if (nextStep && nextStep !== "" && nextStep !== "/" && nextStep !== this.state.currentStep) {
        this.setState({ currentStep: nextStep });
      }
    }

    if (prevProps.areOrdersLoading && !this.props.areOrdersLoading) {
      const upgradingProducts = {};

      this.props.orders.forEach((order) => {
        if (order.upgrading_product && order.status === "pending") {
          upgradingProducts[order.upgrading_product] = order;
        } else if (order.status === "pending") {
          upgradingProducts[order.id] = order;
        }
      });

      this.setState({ upgradingProducts });
    }

    // normalize orders per id so <DomainCards /> components
    // can access them in an efficient way
    if (prevProps.areOrdersLoading && !this.props.areOrdersLoading) {
      let normalizedOrders = {};
      this.props.orders.forEach((o) => (normalizedOrders[o.id] = o));
      this.setState({ normalizedOrders });
    }
  }

  setAddingDomain = () => {
    if (!IS_APP) {
      this.props.history.push("/orders#1");
    }
    this.setState({ isAddingDomain: true, isUpgradingDomain: false });
  };

  setUpgradingDomains = (doms, isUpgradingDomain = false, action = null) => {
    this.setState({ upgradingDomains: doms, isUpgradingDomain, action });
  };

  prevStep = () => {
    let prevStep = this.state.currentStep - 1;
    if (prevStep < 0) prevStep = 0;
    this.goToStep(prevStep);
    return;
  };

  backToList = () => {
    this.props.history.replace("/orders");
    this.setState({
      upgrading: false,
      upgradingDomains: null,
      action: null,
      isAddingDomain: null,
      currentStep: 1,
    });
  };

  goToStep = (step) => {
    if (!IS_APP) {
      this.props.history.push("/orders#" + step);
    }

    this.setState({ currentStep: step });
  };

  setEstimate = (estimate) => {
    this.setState({ estimate: estimate });
  };

  showWHMCInvoice = (o) => {
    let win = window.open("about:blank", "_blank");
    win.focus();
    const api = new QboxmailApi({ useCookie: true });
    return api
      .generateWHMCSUrl("show_invoice", o.id)
      .then((r) => {
        win.location.replace(r.resources[0].url);
      })
      .catch((response) => {
        console.log("error generating whmcs invoice", response);
      });
  };

  submitForm = async () => {
    this.setState({ upgrading: true });

    const doms = this.state.upgradingDomains.map((d) => ({
      max_email_accounts: d.new_8_count,
      max_email_accounts_25gb: d.new_25_count,
      max_email_accounts_50gb: d.new_50_count,
      max_email_accounts_archive: d.new_archive_count,
      plan: d.new_plan,
      name: d.name,
      action: this.state.action,
      calconly: false,
    }));

    const api = new QboxmailApi({ useCookie: true });
    if (this.state.isAddingDomain) {
      try {
        await api.addDomainsToOrder({ domains: doms });
        this.props.refreshLoggedUserData();
        this.props.getOrders({ per: 99999 });
        alertSuccess(t("alert.orderUpdatedSuccess"));
        this.backToList();
      } catch (e) {
        console.error(e);
        alertError(t("alert.orderUpdatedFailed"));
      }
    }

    if (this.state.isUpgradingDomain) {
      try {
        await api.upgradeAnnuallyProduct({ ...doms[0] });
        this.props.refreshLoggedUserData();
        this.props.getOrders({ per: 99999 });
        alertSuccess(t("alert.orderUpdatedSuccess"));
        this.backToList();
      } catch (e) {
        console.error(e);
        alertError(t("alert.orderUpdatedFailed"));
      }
    }

    this.backToList();
  };

  render() {
    const { areDomainsLoading, domains, prices, arePricesLoading, areOrdersLoading } = this.props;
    const { annually, upgradingDomains, isAddingDomain } = this.state;
    const customer = this.context.getLoggedUser();
    const toShow = this.state.steps[this.state.currentStep];

    if (areDomainsLoading || arePricesLoading || areOrdersLoading) return <Loader />;

    if (upgradingDomains || isAddingDomain) {
      return (
        <div className="contentWrapper">
          {React.cloneElement(toShow.component, {
            ...this.props,
            upgradingDomains: upgradingDomains,
            goToStep: this.goToStep.bind(this),
            submitForm: this.submitForm.bind(this),
            backToList: this.backToList,
            isUpgradingDomain: this.state.isUpgradingDomain,
            isAddingDomain: this.state.isAddingDomain,
            setUpgradingDomains: this.setUpgradingDomains,
            stepper: (
              <Stepper
                steps={this.state.isAddingDomain ? 2 : 3}
                active={parseInt(this.state.currentStep, 10)}
                goBack={this.prevStep}
              />
            ),
            upgrading: this.state.upgrading,
            setEstimate: this.setEstimate,
            estimate: this.state.estimate,
            action: this.state.action,
          })}
        </div>
      );
    }

    if (annually) {
      return (
        <YearlyOrder
          prices={prices}
          domains={[...domains, ...customer.ordered_domains]}
          setUpgradingDomains={this.setUpgradingDomains}
          setAddingDomain={this.setAddingDomain}
          upgradingProducts={this.state.upgradingProducts}
          showWHMCInvoice={this.showWHMCInvoice}
          normalizedOrders={this.state.normalizedOrders}
        />
      );
    }

    return <div></div>;
  }
}

OrderScreen.contextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
};

const mapStateToProps = (state) => ({
  domains: resActions.getData("domains.data", state),
  orders: resActions.getData("orders.data", state),
  prices: resActions.getData("prices.data.0", state),
  areDomainsLoading: resActions.isResourceLoading("domains", state),
  arePricesLoading: resActions.isResourceLoading("prices", state),
  areOrdersLoading: resActions.isResourceLoading("orders", state),
});

const mapDispatchToProps = (dispatch) => ({
  getDomains: (queryParams) => dispatch(resActions.callApi("getDomains", "domains", queryParams)),
  getOrders: (queryParams) => dispatch(resActions.callApi("getOrders", "orders", queryParams)),
  getPrices: () => dispatch(resActions.callApi("getPrices", "prices")),
  refreshLoggedUserData: () => {
    dispatch(sessionActions.verify(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderScreen));
